import { useQuery } from '@tanstack/react-query';
import { fetch } from '../fetch';
import { schemas } from '@convergence/client';


export function getTinkerBoxById(tinkerBoxId: number) {
    return fetch(`/tinker-boxes/${tinkerBoxId}`, { method: 'GET' }, schemas.TinkerBox);
}

export const useTinkerBoxQuery = (
    tinkerBoxId: number | undefined | null
) => {
    return useQuery({
        queryKey: ['tinkerbox', tinkerBoxId],
        refetchInterval: 5000,
        networkMode: 'always',
        retry: false,
        enabled: !!tinkerBoxId,
        queryFn: async () => {
            return getTinkerBoxById(tinkerBoxId!);
        }
    });
};
